import React, { useState } from "react";
import "./style.css";
import { MenuItem } from "./MenuItem";
import { useHistory } from "react-router-dom";

export function TopMenu() {
  const history = useHistory();
  const [menuArr] = useState([
    {
      menuName: "网站首页",
      url: "/",
    },
    {
      menuName: "新闻动态",
      url: "/news",
    },
    {
      menuName: "数据产品",
      url: "/datas",
    },
    {
      menuName: "技术应用",
      url: "/techs",
    },
    {
      menuName: "区域遥感",
      url: "/sensor",
    },
    {
      menuName: "关于我们",
      url: "/about",
    },
    {
      menuName: "公司招募",
      url: "/recruite",
    },
    {
      menuName: "联系我们",
      url: "/contacts",
    },
    {
      menuName: "文件下载",
      url: "/resource",
    },
  ]);
  const getActive = (url) => {
    return window.location.pathname == url
      ? "menu_item menu_item_active"
      : "menu_item";
  };
  return (
    <div>
      <div className="top">
        <div className="header">
          <div className="logo">
            <img src="./img/logo2.png" />
          </div>
          <div className="menu">
            {menuArr.map((i) => {
              return (
                <div
                  className={getActive(i.url)}
                  key={i.menuName}
                  onClick={() => {
                    localStorage.removeItem("curPage");
                    localStorage.removeItem("typeName");
                    history.push(i.url);
                  }}
                >
                  <MenuItem value={i.menuName} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
